// translations/pages/landing/sv.js

export const landingPageSV = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Lokala AI-lösningar med dataskydd i fokus",
    "vision": "Nästa steg i produktivitet: Organisation as a Service. AI-medarbetare tar arbetet från idé till verifierat resultat.",
    "intro": "Vi forskar om, utvecklar och integrerar teknik inom artificiell intelligens, maskininlärning och databehandling. Resultatet är egna produkter och kundspecifika lösningar som analyserar, strukturerar, anonymiserar och skyddar data lokalt — samt med [Veridion](veridion) helt automatiserade AI-medarbetare som tillsammans med människor tar hand om hela arbetsområden i företaget.",
    "detail": "Programvara som vi installerar hos kunden körs i kundens egen infrastruktur och kräver ingen molnanslutning. Dokument, data och språkmodeller stannar inom den egna verksamheten."
  },
  "partners": {
    "title": "Partner som litar på oss",
    "subtitle": "Företag och forskningsinstitutioner där vår AI-organisation är i skarp drift.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nEye-tracking- och biosignallösningar för er forskning",
        "description": [
          "BiSigma är specialiserat på system för mätning och analys av biosignaler samt högprecisionslösningar för ögonrörelsemätning (eye-tracking) för vetenskap, klinik och industriell forskning.",
          "pAIoneer Labs GmbH har hos BiSigma helt ersatt mjukvaruutvecklingen med AI, som framgångsrikt utvecklar och vidareutvecklar programvara för mätning och analys av biosignaler."
        ],
        "cta": "Besök BiSigma"
      }
    }
  },
  "products": {
    "title": "Produkter",
    "subtitle": "Vi säljer programvara i form av skrivbordsprogram för arbetsplatsen, serverprogramvara on-premises eller i kundens moln och prenumerationer på vår plattform, till exempel [tradingassistenten](finance), som våra AI-medarbetare själva utvecklar. Dessutom bygger vi AI-system enligt kundens krav och erbjuder rådgivning och utbildning.",
    "partnerLabel": "Partnerprodukt",
    "priceOnRequest": "Pris på förfrågan",
    "request": "Skicka en förfrågan",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil identifierar och anonymiserar personuppgifter i Word-, Excel-, OpenDocument-, PDF- och textfiler innan de går vidare till AI-verktyg, tester, analyser eller tredje part. Identifieringen kombinerar {presidio}, {spacy} och {flair} och fungerar på tyska, engelska, franska, italienska och spanska.",
          "Skrivbordsversionen körs fristående på vanliga datorer med Windows, macOS eller Linux, utan GPU och utan nätverksberoende; filerna lämnar aldrig arbetsstationen. API-versionen körs i kundens infrastruktur, on-premises eller i kundens eget moln, och bygger in anonymiseringen i befintliga system och arbetsflöden.",
          "Replace-läget ersätter personuppgifter med platshållare för dokumentation av regelefterlevnad, Fake-läget med plausibla ersättningsvärden för testmiljöer; dokumentstrukturen bevaras. Med AnonChat når ett anonymiserat dokument ChatGPT, Claude, Gemini eller en intern språkmodell först efter en förhandsvisning."
        ],
        "cta": "Visa Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "En skapare, oändligt många lösningar.",
        "text": [
          "Företags-AI:n hos pAIoneer Labs GmbH: den styr hela företaget, som en komplett organisation av AI-medarbetare med affärsområden från mjukvaruutveckling via elektronik och kvantdatorteknik till försäljning och administration, ledda av ett eget koordinationsskikt.",
          "Denna arbetsstyrka slutför projekt, bokföring, företagskunskap, research, utveckling och dataanalys på egen hand. Dess kommunikation är spelteoretiskt optimerad, och behöver den en förmåga som ännu inte finns, bygger den ett eget AI-system för den.",
          "Den drivs on-premises, i eget moln eller på vår plattform. Där utvecklar den själv [tradingassistenten](finance) och är AI:n i dess chatt."
        ],
        "points": [
          "Integrerar sig i varje process",
          "Lär sig på egen hand",
          "Skapar saknade förmågor själv",
          "Planerbar i fasta cykler"
        ],
        "cta": "Visa Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy är ett AI-baserat, modulärt agentsystem för företag som automatiserar administrativa kontorsuppgifter.",
          "Fem roller täcker arbetsdagen: assistenten samordnar möten, skriver utkast till e-postmeddelanden och sköter dagliga uppgifter. Coachen stöttar i arbetslivets känslomässiga och sociala sidor, hjälper till vid konflikter och stöder den personliga utvecklingen. Dataskyddshjälpen besvarar sakfrågor om dataskydd och integritet och kan tränas på ytterligare specialområden som brandskydd eller regelefterlevnad. Utbildaren tar fram vidareutbildningsplaner, introduktionsprogram och utbildningsmoduler, och rådgivaren analyserar uppladdade dokument, stöder beslut och ger strategiska rekommendationer.",
          "RoBuddy hostas och förvaltas till 100 % enligt tyska standarder (GDPR, BSI-Grundschutz) och kan anslutas sömlöst till Nextcloud eller valfri nätverksenhet.",
          "RoBuddy är det agentiska systemet för kontorsarbete och kan kopplas samman med Veridion till en företags-AI som omfattar hela företaget: RoBuddy tar hand om uppgifterna på arbetsplatsen, Veridion ansluter företagets system och data."
        ],
        "cta": "Visa RoBuddy",
        "vendorNote": "RoBuddy är en produkt från Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. Försäljningen sköts av pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS-plattform",
    "description": "Du använder den här applikationen som prenumeration direkt i webbläsaren, utan installation. Den körs på vår egen plattform, inloggningen kräver en andra faktor och alla AI-anrop går via en central åtkomstpunkt med fasta kvoter.",
    "apps": {
      "finance": {
        "name": "AI-tradingassistent",
        "text": "Du ansluter din värdepappersdepå, ställer frågor om dina positioner på vanligt språk och ser vilka nyheter som har påverkat kurserna. Prognosen för varje finansiellt instrument beräknas av en egen maskininlärningsmodell som tränas om varje dag, och en automatik kan handla på signalerna. Assistenten utvecklas av våra AI-medarbetare; i chatten är de också dess AI.",
        "cta": "Visa tradingassistenten"
      }
    }
  },
  "services": {
    "title": "Kärntjänster",
    "veridion": {
      "title": "AI-medarbetare",
      "description": "Hela arbetsfält, bemannade med AI-medarbetare som integrerar sig i företagets processer och verktyg och slutför arbetet på egen hand. Så arbetar vi själva: pAIoneer Labs GmbH drivs genom det.",
      "cta": "Visa Veridion",
      "features": [
        "Organisation as a Service",
        "Affärsområden av AI-medarbetare",
        "Spelteoretiskt optimerad kommunikation",
        "On-premises eller eget moln"
      ]
    },
    "custom": {
      "title": "Kundanpassade AI-system",
      "description": "Vi utvecklar system för analys, bearbetning, strukturering, anonymisering och skydd av data enligt kundens krav och integrerar dem i lokal eller kundägd IT-infrastruktur.",
      "features": [
        "Drift utan moln",
        "Produktutveckling",
        "Prototyper",
        "Forsknings- och utvecklingsprojekt"
      ]
    },
    "elektronik": {
      "title": "Elektronik & firmware",
      "description": "Hårdvarunära utveckling som tjänst: kretskonstruktion och simulering som digital tvilling, firmware ända ned till sensorn, bedömning av komponenter och alternativ innan något tillverkas.",
      "features": [
        "Digitala tvillingar",
        "Embedded-firmware",
        "Databladsanalys",
        "Komponentbedömning"
      ]
    },
    "quantum": {
          "title": "Suveräna LLM & Kvant-AI",
          "description": "Vårt mål under Veridion: att utveckla kompakta språkmodeller Made in Germany som i framtiden konkurrerar med stora modeller från USA och Kina, samt egna Quantum Transformers.",
          "cta": "Visa Quantum",
          "features": [
                "LLM Made in Germany",
                "Quantum Transformers",
                "Egen Quantum IDE",
                "AI utvecklar AI"
          ]
    },
    "dataanalysis": {
      "title": "Dataanalys i samtal",
      "description": "En AI-medarbetare besvarar frågor till anslutna datakällor. Den läser databasernas kataloger, scheman och kolumner, lägger fram en analysplan före dataåtkomsten och reder ut tvetydigheter.",
      "features": [
        "SQL-datakällor",
        "Korrelation och regression",
        "Tabeller och diagram",
        "Export till PDF och PowerPoint"
      ]
    },
    "memory": {
      "title": "Företagsminne",
      "description": "Ett minne i stället för en dokumentsökning: fakta, beslut, uppgifter och rutiner, kopplade till de projekt, personer, system och dokument de hör till, samt den tid då de gäller. Det växer av sig självt ur samtal, möten och arbetsresultat; ett nyare beslut ersätter det äldre i samma fråga, inget går förlorat.",
      "features": [
        "Kunskapsgraf",
        "Fakta med tidsangivelse",
        "Beslut, aldrig förlorade",
        "Åtkomst efter ansvarsområde"
      ]
    },
    "kyveil": {
      "title": "Lokal anonymisering utan GPU",
      "description": "Kyveil anonymiserar personuppgifter lokalt, som skrivbordsprogram på vanliga datorer med Windows, macOS eller Linux eller som REST-API i kundens infrastruktur, utan molnberoende och utan GPU.",
      "cta": "Visa Kyveil",
      "features": [
        "Anonymisering före AI",
        "PII-identifiering med NLP",
        "Windows, macOS, Linux",
        "REST-API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "AI-stödd mjukvaruutveckling behöver tillförlitlig kontext. IDD dokumenterar mål, icke-mål, scenarier, agentregler och beslut som ett användbart projektminne.",
      "cta": "Visa IDD",
      "features": [
        "Agentisk utveckling",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Scenarier som tester"
      ]
    },
    "finance": {
      "title": "Finans & marknadsanalys",
      "description": "Bakom tradingassistenten står ett eget affärsområde av digitala medarbetare: AI-data scientists och finansexperter. De utvärderar nyheter i realtid, analyserar känslorna i finansnyheterna och räknar själva på marknadsdata i chatten: korrelationer, regressioner, diagram och utfallet av de egna prognoserna, varje siffra från ett utfört beräkningssteg. Därunder arbetar en maskininlärningsprognos per finansiellt instrument och automatiserad handel på demokonto och i skarpt läge.",
      "cta": "Visa finans-AI",
      "features": [
        "AI-data scientists & finansexperter",
        "Nyheter i realtid, med känsloanalys",
        "ML-prognos per finansiellt instrument",
        "Automatiserad handel"
      ]
    },
    "consulting": {
      "title": "Rådgivning",
      "description": "Vi ger teknisk, organisatorisk och strategisk rådgivning vid införande, säkring och regelkonform användning av AI.",
      "features": [
        "AI governance",
        "Datahantering",
        "Dataskydd",
        "Informationssäkerhet"
      ]
    }
  },
  "contact": {
    "title": "Kontakt",
    "addressLabel": "Adress",
    "phoneLabel": "Telefon",
    "emailLabel": "E-post",
    "cta": "Skriv ett meddelande"
  }
};
